import {Component, Inject, OnInit} from '@angular/core';
import {
  annuelNumber,
  EtablissementData,
  etablissementType,
  EtablissmentTypes,
  salaryNumber,
} from "../../../../../shared/utils/data/etablissments-data";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {CustomDialogComponent} from "../../../../../shared/custom-dialog/custom-dialog.component";
import {Establishment} from "../../../../../models/Establishment";
import {EstablishmentService} from "../../../../../services/establishment.service";
import {FlagService} from "../../../../../shared/services/flag.service";
import {FlagType} from "../../../../../shared/utils/enums";

@Component({
  selector: 'app-mon-etablissement-detail-dialog',
  templateUrl: './mon-etablissement-detail-dialog.component.html',
  styleUrl: './mon-etablissement-detail-dialog.component.scss'
})
export class MonEtablissementDetailDialogComponent implements OnInit {

  protected readonly EtablissmentTypes = EtablissmentTypes;

  // AnnualPatientArray = AnnualPatientArray
  form: FormGroup;
  loading = false;
  // constructor() {
    constructor( public dialogRef: MatDialogRef<MonEtablissementDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Establishment,
                 private fb: FormBuilder,
                 private flag: FlagService,
                 private establishmentService: EstablishmentService,
                 private dialog: MatDialog) {

    }



  ngOnInit(): void {
    this.form = this.fb.group({
      name: [this.data.name, Validators.required],
      // Primary contact email — now editable (also drives inbound mail → mission extraction matching).
      mailpersonnecontact: [this.data.mailpersonnecontact, [Validators.required, Validators.email]],
      description: [this.data.description],
      numsiret: [this.data.numsiret, [Validators.minLength(14), Validators.maxLength(14)]],
      numfiness: [this.data.numfiness, [Validators.minLength(9), Validators.maxLength(9)]],
      typeetablissement: [this.data.typeetablissement],
      nombresalaries: [this.data.nombresalaries],
      nombreannuelpatients: [this.data.nombreannuelpatients],
      fonctionpersonnecontact: [this.data.fonctionpersonnecontact],
      // Null-safe: some establishments have no persons yet — must not crash the whole edit form.
      fullnamepersonnecontact: [
        this.data.fullnamepersonnecontact ||
          (this.data.persons && this.data.persons[0]
            ? ((this.data.persons[0].firstName || '') + ' ' + (this.data.persons[0].lastName || '')).trim()
            : ''),
      ],
      platformManagedBy: [this.data.platformManagedBy],
    })
  }

  editEstablishment() {
    this.loading = true;
      const body = {
        ...this.data,
        ...this.form.value,
        adresses: [],
        persons: []
      }
    this.establishmentService.updateEstablishment(body, this.data.id).subscribe({
      next: () => {
        this.dialogRef.close(true)
      },
      error: () => {
        this.flag.displayFlag('Une erreur est survenue !', FlagType.error)
      },
      complete: () => {this.loading = false},
    })
  }

  close(param?: boolean) {
    this.dialogRef.close(param)
  }
  checkBoxChange(e: any, value: string) {
    this.form.get('platformManagedBy')?.patchValue(value)
  }
    cancelAction() {
      const dialogRef  = this.dialog.open(CustomDialogComponent, {
        data: {
          title: EtablissementData.monEtablissement.titleVerificationDialog,
          description: EtablissementData.monEtablissement.descriptionVerificationDialog,
          primaryLabel: EtablissementData.monEtablissement.fistLabelVerificationDialog,
          secondaryLabel: EtablissementData.monEtablissement.secondLabelVerificationDialog,
        },
        maxWidth: '700px',
        autoFocus: false
      })
      dialogRef .afterClosed().subscribe(res => {
        if (!res) {
          this.close();
        }
      })
    }

  protected readonly salaryNumber = salaryNumber;
  protected readonly annuelNumber = annuelNumber;
  protected readonly etablissementType = etablissementType;
}
